import { Checkbox } from '@material-ui/core';
import React from 'react';
import { SvgTBRCheckboxEmpty, SvgTBRCheckboxFilled, SvgTBRCheckboxHalf } from './item-list-icons';
import { styles } from './item-list-styles';

const TBRCheckbox: React.FC<ITBRCheckboxProps> = (props: ITBRCheckboxProps): JSX.Element => {
  const classes = styles();
  const { checked, onChange } = props;

  return (
    <Checkbox
      className={classes.checkboxTBR}
      icon={<SvgTBRCheckboxEmpty data-testid='empty-tbr-checkbox' />}
      checkedIcon={<SvgTBRCheckboxFilled data-testid='complete-tbr-checkbox' />}
      checked={checked}
      indeterminate={checked === undefined}
      indeterminateIcon={<SvgTBRCheckboxHalf data-testid='partial-tbr-checkbox' />}
      onChange={onChange}
    />
  );
};

export interface ITBRCheckboxProps {
  checked?: boolean;
  onChange?: () => void;
}

export default TBRCheckbox;
